import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

import { IValuesStore } from "@src/Stores/Values/types";
import { Formik, FormikProps, FormikActions } from "formik";
import QuickLoginForm from "./QuickLoginForm/QuickLoginForm";
import { IAuthStore } from "@src/Stores/Auth/types";
import { oauthLogInRoute, oauthLogInErrorRoute } from "@src/Stores/Auth/types";
import { RouterStore } from "mobx-react-router";
import PostBackFormSubmittion from "@src/Tools/PostBackFormSubmittion";
import { STLocationGrid } from "./QuickLoginForm/styles";
import { STSelectLocation } from "../SelectLocation/styles";
import { RouteComponentProps } from "react-router-dom";
import { IAuthByPinRequestOptions } from "../../../../Interfaces/AuthRequest";

interface IProps extends RouteComponentProps {
  values?: IValuesStore;
  auth?: IAuthStore;
  routing?: RouterStore;
}

export interface IQuickLoginForm {
  password: string;
  location: string;
}

@inject("values", "auth", "routing")
@observer
export default class QuickLogin extends React.Component<IProps> {
  @observable lastLocation: string = "";

  constructor(props: IProps) {
    super(props);

    const lastLocation: string = localStorage.getItem("lastLocation");

    if (lastLocation) {
      this.lastLocation = lastLocation;
    }
  }

  handleSubmit = async (values: IQuickLoginForm, actions: FormikActions<IQuickLoginForm>) => {
      //OAuth case
      const { routing } = this.props;
      if ((routing.location.pathname.match(oauthLogInRoute) || this.props.location.pathname.match(oauthLogInErrorRoute)) && routing.location.search.match("response_type=code")) {
          let options: IAuthByPinRequestOptions = {
              pin: values.password,
              location: values.location
          }
          await this.props.auth.signInViaOAuth2ByPin(options, routing.location.search);
      } else {
          const tenantParam = new URLSearchParams(this.props.location.search).get("tenant");
          const response: boolean = await this.props.auth.signInByPin(values.password, values.location, tenantParam);
          const authResults = await this.props.auth.checkAuth();
          if (response && authResults && this.props.routing.location.search.match("ssopostback")) {
              const token: string = await this.props.auth.getToken();
              //There is a problem in the documentation - the user is redirected to the forbidden page if another user who has no rights was logged in before
              var searchWithoutForbidden = this.props.location.search.replace("forbidden", "");
              PostBackFormSubmittion(token, searchWithoutForbidden + this.props.routing.location.hash);
          } else if (response && authResults) {
              await this.props.auth.getUserDetails();
              this.props.routing.history.push("/");
          }
      }
    if (values.location) {
      localStorage.setItem("lastLocation", values.location);
    }
    actions.setFieldValue("password", "");
  };

  render() {
    return (
      <Formik
        initialValues={{
          password: "",
          location: this.props.values.location ? this.props.values.location : this.lastLocation,
        }}
        onSubmit={this.handleSubmit}
        render={(formikProps: FormikProps<IQuickLoginForm>) => (
          <>
            <STLocationGrid>
              {!this.props.values.location && (
                <STSelectLocation value={formikProps.values.location} formikProps={formikProps} />
              )}
            </STLocationGrid>
            <QuickLoginForm formikProps={formikProps} />
          </>
        )}
      />
    );
  }
}
